export default "__VITE_ASSET__cf1071df__"